import React from "react";
import { useHttp } from "../../hooks/http.hook";
import TableWrap from "../components/Table/TabelWrap";
import tableCss from '../components/Table/style.module.scss'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import useAuth from "../../hooks/useAuth.hook";
import { InputBase } from "@mui/material";
import Preloader from '../components/Preloader'
import ResenderToggle from "../components/ResenderTogggle/ResenderToggle";
import { toast } from "react-toastify";
import LeadItem from "./LeadItem";


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


const Resend = () => {
    const auth = useAuth()

    const [leads, setLeads] = React.useState([])
    const [nameFilter, setNameFilter] = React.useState('')

    const { request, loading } = useHttp()
    const { request: sendLeadReq, loading: sendLeadLoad } = useHttp();


    const headers = ['', '', 'Created At', 'First Name', 'Last Name', 'Email', 'Phone', 'Ref', 'Link']

    const getLeads = async (e) => {
        const res = await request(`/api/main/resend/leads`)
        setLeads([...res.resendLeads])
    }

    React.useEffect(() => {
        getLeads()
    }, [])

    const nameFilterHandler = (event) => {
        setNameFilter(event.target.value)
    }

    const sendLeadNow = React.useCallback(async (id) => {
        toast.promise(
            sendLeadReq(`/api/main/resender/send/lead/${id}`, 'GET', null, { Authorization: `Bearer ${auth.token}` })
                .then(res => {
                    const { resData } = res;

                    if (!resData) {
                        console.error('Lead sending failed');
                        throw new Error('Lead sending failed', {
                            statusCode: 500,
                            leadId: id
                        })
                    }

                    if (resData.statusCode && resData.statusCode === 200) {
                        console.log("Status: ", resData.statusCode);
                        setLeads(prevLeads => prevLeads.filter(lead => lead.id !== id));
                        return 'Lead sent successfully';
                    } else {
                        console.error('Lead sending failed');
                        throw new Error('Lead sending failed', {
                            // status 500
                            statusCode: 500,
                            leadId: id
                        });
                    }
                }
                ),
            {
                pending: 'Sending lead...',
                success: {
                    render({ data }) {
                        return data;
                    },
                    autoClose: 1000, // Устанавливаем время отображения на 500 мс
                },
                error: {
                    render({ data }) {
                        setLeads(prevLeads => prevLeads.filter(lead => lead.id !== id));
                        return data instanceof Error ? data.message : data;
                    },
                    autoClose: 1000, // Устанавливаем время отображения на 500 мс
                },
            }
        ).catch(error => {
            console.error(error);
        });
    }, [auth.token, sendLeadReq]);


    const handleDelete = async (id) => {
        try {
            await request(`/api/main/resend/remove/${id}`, 'POSt', {}, { Authorization: `Bearer ${auth.token}` })
            setLeads(leads.filter(lead => lead.id !== id));
        } catch (error) {
            console.error(error);
        }
    };

    // Обчислюємо список відфільтрованих записів для відображення
    const filteredLeads = leads.filter(lead => (lead.first_name + " " + lead.last_name + " " + lead.email).includes(nameFilter));

    return <div className="card" >
        <Box sx={{ p: '2px 4px', m: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

            <h2>Leads in Resend ({filteredLeads.length})</h2>
            <div style={{ display: "flex", gap: "10px" }}>
                <ResenderToggle />
            </div>
        </Box>
        <Paper sx={{ p: '2px 4px', m: 2, display: 'flex', alignItems: 'center' }}>
            <InputBase
                type="search"
                sx={{ ml: 1, flex: 1 }}
                placeholder="Name, Last Name or Email"
                onChange={nameFilterHandler}
                value={nameFilter}
            />
        </Paper>
        {loading && <Preloader />}
        {!loading && leads.length === 0 && <h2>No Results</h2>}
        {!loading && leads.length > 0 && <TableWrap>
            <div className={tableCss.table}>
                <div className={tableCss.header} style={{ "gridTemplateColumns": `25px 40px 90px repeat(4,minmax(100px, 1fr)) 200px 100px 90px 120px` }}>
                    {headers.map(header => <div>
                        {header}
                    </div>)}
                </div>
                <div className={tableCss.content}>
                    {filteredLeads
                        .map((lead, index) =>
                            <LeadItem
                                key={lead.id + '-' + index}
                                lead={lead}
                                index={index}
                                handleDelete={handleDelete}
                                sendLeadNow={sendLeadNow}
                            />
                        )}
                </div>
            </div>
        </TableWrap>}
    </div>
}

export default Resend